import React, { useCallback, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { useSocket } from '../../SocketContext';
import useNotificationChime from '../../hooks/useNotificationChime';
import CustomMailNotificationContent from '../CustomMailNotificationContent';

const EmailNotificationPush = ({ userId }) => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const { playChime } = useNotificationChime({ requireInteractionForPlay: false });
  const socket = useSocket();

  const handleEmailNotification = useCallback((notification) => {
    if (
      notification.user &&
      userId &&
      notification.user.toString() === userId.toString() &&
      notification.type === 'newEmail'
    ) {
      playChime();
      window.dispatchEvent(new Event('refreshEmails'));
      enqueueSnackbar('', {
        variant: 'emailNotification',
        content: (key) => (
          <CustomMailNotificationContent
            key={key}
            message={notification}
            closeSnackbar={() => closeSnackbar(key)}
          />
        )
      });
    }
  }, [userId, enqueueSnackbar, closeSnackbar, playChime]);

  useEffect(() => {
    if (!socket) return;
    socket.on('notificationCreated', handleEmailNotification);
    return () => socket.off('notificationCreated', handleEmailNotification);
  }, [socket, handleEmailNotification]);

  return null;
};

export default EmailNotificationPush;
